import * as React from 'react';
import { observer } from 'src/utils/mobx-react';
import { getError } from 'src/domains/layouts/webview/components/common/errorMessage/getError';
import { InfoMessageWrapper, InfoIconWrapper } from './styles';
import { UniverseType } from 'src_common/common/universe';
import { UniverseVersion } from 'src/domains/common/UniverseVersion';

import { ConfigComponents } from 'src/domains/layouts/config/features/config';
import { useCommon } from 'src/domains/common/Common';

interface InfoMessageDeprecatedPropsType {
    message?: string | {};
    children?: React.ReactNode;
    backgroundColor?: 'default' | 'transparent';
    hasMargin?: boolean;
    hasIcon?: boolean;
    className?: string;
}

// TODO - Temporary solution, introduced to not change getErrors file, for errors that contain message only
const parseErrorMessage = (error: string | undefined): undefined | string => error?.split(':undefined')[0];

/** * @deprecated - Please use {@link Messages} instead. */
export const InfoMessageDeprecated = observer('InfoMessage', (props: InfoMessageDeprecatedPropsType): JSX.Element => {
    const { className, message, children, backgroundColor = 'default', hasIcon = true, hasMargin = true } = props;
    const common = useCommon();
    const configState = ConfigComponents.get(common).config;

    return (
        <InfoMessageWrapper
            backgroundColor={backgroundColor}
            className={className}
            hasIcon={hasIcon}
            hasMargin={hasMargin}
            variant={configState.componentVariants.betslipVariant}
        >
            {hasIcon ? <InfoIconWrapper /> : null}
            <UniverseVersion>
                {(universe: UniverseType): React.ReactElement => (
                    <div data-test='info-message-content'>
                        {parseErrorMessage(getError(universe, message))}
                        {children !== undefined && children}
                    </div>
                )}
            </UniverseVersion>
        </InfoMessageWrapper>
    );
});
